(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["french-flashcards"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-french-flashcards]:not([data-fbfc-ready])');
    const audioLike = (value) => typeof value === 'string' && (/\.mp3(?:\?|$)/i.test(value) || /^https?:\/\//i.test(value) || value.startsWith('//'));
    const sentenceLike = (value) => {
      const text = String(value || '').trim();
      return /[.!?…]$/.test(text) || text.split(/\s+/).filter(Boolean).length >= 5;
    };
    const safeJson = (node, fallback = []) => {
      try { return JSON.parse(node?.textContent || ''); }
      catch (_error) { return fallback; }
    };
    const format = (template, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`__${key}__`, String(value)), template || '');
    const cleanTitle = (value, fallback) => String(value || fallback || '').replace(/\s*[–—|-]\s*waifed\s*$/i, '').trim();

    const initialize = (root) => {
      root.dataset.fbfcReady = 'true';
      const i18n = safeJson(root.querySelector('[data-fbfc-i18n]'), {});
      const member = root.dataset.member === 'true';
      const pagePrefix = root.dataset.pagePrefix || '/pages/french-';
      const discoveryLimit = Number(root.dataset.discoveryLimit || 80);
      const storageKey = 'waifed:french-flashcards:v1';
      const elements = {
        direction: root.querySelector('[data-fbfc-direction]'),
        mode: root.querySelector('[data-fbfc-mode]'),
        source: root.querySelector('[data-fbfc-source]'),
        category: root.querySelector('[data-fbfc-category]'),
        shuffle: root.querySelector('[data-fbfc-shuffle]'),
        restart: root.querySelector('[data-fbfc-restart]'),
        review: root.querySelector('[data-fbfc-review]'),
        load: root.querySelector('[data-fbfc-load]'),
        error: root.querySelector('[data-fbfc-error]'),
        workspace: root.querySelector('[data-fbfc-workspace]'),
        empty: root.querySelector('[data-fbfc-empty]'),
        locked: root.querySelector('[data-fbfc-locked]'),
        lockedCopy: root.querySelector('[data-fbfc-locked-copy]'),
        backToDeck: root.querySelector('[data-fbfc-back-to-deck]'),
        card: root.querySelector('[data-fbfc-card]'),
        front: root.querySelector('[data-fbfc-front]'),
        back: root.querySelector('[data-fbfc-back]'),
        frontLanguage: root.querySelector('[data-fbfc-front-language]'),
        backLanguage: root.querySelector('[data-fbfc-back-language]'),
        sourceLabel: root.querySelector('[data-fbfc-source-label]'),
        categoryLabel: root.querySelector('[data-fbfc-category-label]'),
        kindLabel: root.querySelector('[data-fbfc-kind-label]'),
        audio: root.querySelector('[data-fbfc-audio]'),
        previous: root.querySelector('[data-fbfc-previous]'),
        flip: root.querySelector('[data-fbfc-flip]'),
        next: root.querySelector('[data-fbfc-next]'),
        again: root.querySelector('[data-fbfc-again]'),
        known: root.querySelector('[data-fbfc-known]'),
        progress: root.querySelector('[data-fbfc-progress]'),
        reviewCount: root.querySelector('[data-fbfc-review-count]'),
        total: root.querySelector('[data-fbfc-total]'),
        sourceCount: root.querySelector('[data-fbfc-source-count]'),
        sentenceCount: root.querySelector('[data-fbfc-sentence-count]'),
        live: root.querySelector('[data-fbfc-live]')
      };
      const state = {
        cards: [],
        filtered: [],
        sources: new Map(),
        categories: new Map(),
        index: 0,
        flipped: false,
        locked: false,
        reviewOnly: false,
        reviewIds: new Set(),
        loadedSources: 0,
        failedSources: 0,
        discoveredSources: 0,
        lockedCount: 0,
        currentAudio: null
      };

      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
        if (Array.isArray(saved.reviewIds)) state.reviewIds = new Set(saved.reviewIds.filter((value) => typeof value === 'string'));
        if (saved.direction === 'en-fr') elements.direction.value = 'en-fr';
        if (['mixed', 'vocabulary', 'sentence'].includes(saved.mode)) elements.mode.value = saved.mode;
      } catch (_error) {
        state.reviewIds = new Set();
      }

      const save = () => {
        try {
          localStorage.setItem(storageKey, JSON.stringify({
            reviewIds: [...state.reviewIds],
            direction: elements.direction.value,
            mode: elements.mode.value
          }));
        } catch (_error) {}
      };

      const stopAudio = () => {
        if (state.currentAudio) {
          state.currentAudio.pause();
          state.currentAudio.currentTime = 0;
        }
        state.currentAudio = null;
        elements.audio?.removeAttribute('aria-busy');
      };

      const resolveAudio = (value, audioBase) => {
        const source = String(value || '').trim();
        if (!source) return '';
        if (/^https:\/\//i.test(source)) return source;
        if (source.startsWith('//')) return `${window.location.protocol}${source}`;
        if (source.startsWith('/')) return new URL(source, window.location.origin).href;
        if (audioBase) return `${audioBase}${encodeURIComponent(source)}`;
        return '';
      };

      const makeCard = (input) => {
        const french = String(input.french || '').trim();
        const english = String(input.english || '').trim();
        if (!french || !english) return null;
        return {
          id: `${input.sourceId}:${input.dataset}:${input.rowIndex}:${input.variant || 'main'}`,
          french,
          english,
          audio: resolveAudio(input.audio, input.audioBase),
          audioSecondary: resolveAudio(input.audioSecondary, input.audioBase),
          category: String(input.category || input.sourceTitle).trim(),
          categoryKey: `${input.sourceId}::${String(input.categoryKey || input.category || input.sourceTitle).trim()}`,
          sourceId: input.sourceId,
          sourceTitle: input.sourceTitle,
          sourceUrl: input.sourceUrl,
          kind: input.kind || (sentenceLike(french) ? 'sentence' : 'vocabulary'),
          free: Boolean(input.free)
        };
      };

      const normalizeRow = (row, context) => {
        const base = { ...context };
        if (row && !Array.isArray(row) && typeof row === 'object') {
          const cards = [];
          const main = makeCard({
            ...base,
            french: row.french || row.term || row.word,
            english: row.english || row.translation || row.meaning,
            audio: row.audio_url || row.audio || row.audio_key,
            category: row.category || row.cefr_level || base.sourceTitle,
            categoryKey: row.category || row.cefr_level || base.sourceTitle
          });
          if (main) cards.push(main);
          const examples = [
            [row.example_french, row.example_english],
            [row.french_sentence, row.english_sentence]
          ];
          examples.forEach(([french, english], index) => {
            const example = makeCard({ ...base, french, english, category: row.category || base.sourceTitle, kind: 'sentence', variant: `example-${index + 1}` });
            if (example) cards.push(example);
          });
          return cards;
        }
        if (!Array.isArray(row)) return [];
        if (row.length >= 10 && context.dataset.includes('fmm')) {
          return [
            makeCard({ ...base, french: row[0], english: `${row[3]}; ${row[6]}`, audio: row[9], category: row[1], categoryKey: row[1], variant: 'word' }),
            makeCard({ ...base, french: row[4], english: row[5], category: row[1], categoryKey: row[1], kind: 'sentence', variant: 'sentence-1' }),
            makeCard({ ...base, french: row[7], english: row[8], category: row[1], categoryKey: row[1], kind: 'sentence', variant: 'sentence-2' })
          ].filter(Boolean);
        }
        if (row.length === 7) {
          return [makeCard({
            ...base,
            french: `${row[0]} ↔ ${row[1]}`,
            english: `${row[2]} ↔ ${row[3]}`,
            category: row[4],
            categoryKey: row[4],
            audio: row[5],
            audioSecondary: row[6]
          })].filter(Boolean);
        }
        if (row.length === 6) {
          if (Number.isFinite(Number(row[4])) && audioLike(row[2])) {
            const categoryLabel = context.categoryLabels.get(String(row[5])) || row[5];
            return [makeCard({ ...base, french: row[0], english: row[1], audio: row[2], category: categoryLabel, categoryKey: row[5] })].filter(Boolean);
          }
          return [makeCard({
            ...base,
            french: `${row[0]} / ${row[1]}`,
            english: row[2],
            category: row[3],
            categoryKey: row[3],
            audio: row[4],
            audioSecondary: row[5]
          })].filter(Boolean);
        }
        if (row.length >= 5) {
          if (audioLike(row[2]) && Number.isFinite(Number(row[3]))) {
            const categoryLabel = context.categoryLabels.get(String(row[4])) || row[4];
            return [makeCard({ ...base, french: row[0], english: row[1], audio: row[2], category: categoryLabel, categoryKey: row[4] })].filter(Boolean);
          }
          return [makeCard({
            ...base,
            french: row[0],
            english: row[1],
            audio: row[4],
            category: typeof row[3] === 'string' ? row[3] : row[2],
            categoryKey: typeof row[3] === 'string' ? row[3] : row[2]
          })].filter(Boolean);
        }
        return [];
      };

      const setOptions = () => {
        const sourceValue = elements.source.value;
        const categoryValue = elements.category.value;
        elements.source.replaceChildren(new Option(root.querySelector('[data-fbfc-source] option')?.textContent || 'All sources', 'all'));
        [...state.sources.entries()].sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => elements.source.add(new Option(label, value)));
        elements.category.replaceChildren(new Option(root.querySelector('[data-fbfc-category] option')?.textContent || 'All categories', 'all'));
        [...state.categories.entries()].sort((a, b) => a[1].localeCompare(b[1])).forEach(([value, label]) => elements.category.add(new Option(label, value)));
        elements.source.value = state.sources.has(sourceValue) ? sourceValue : 'all';
        elements.category.value = state.categories.has(categoryValue) ? categoryValue : 'all';
        elements.source.disabled = state.sources.size < 1;
        elements.category.disabled = state.categories.size < 1;
      };

      const updateSummary = () => {
        const sentenceCount = state.cards.filter((card) => card.kind === 'sentence').length;
        elements.total.textContent = state.cards.length.toLocaleString();
        elements.sourceCount.textContent = format(i18n.sourceCount, { count: state.sources.size.toLocaleString() });
        elements.sentenceCount.textContent = format(i18n.sentenceCount, { count: sentenceCount.toLocaleString() });
        elements.reviewCount.textContent = format(i18n.reviewCount, { count: state.reviewIds.size.toLocaleString() });
        elements.review.disabled = state.reviewIds.size === 0;
        elements.shuffle.disabled = state.cards.length === 0;
        elements.restart.disabled = state.cards.length === 0;
      };

      const render = () => {
        stopAudio();
        const source = elements.source.value;
        const category = elements.category.value;
        const mode = elements.mode.value;
        state.filtered = state.cards.filter((card) => {
          if (source !== 'all' && card.sourceId !== source) return false;
          if (category !== 'all' && card.categoryKey !== category) return false;
          if (mode !== 'mixed' && card.kind !== mode) return false;
          if (state.reviewOnly && !state.reviewIds.has(card.id)) return false;
          return true;
        });
        state.index = Math.max(0, Math.min(state.index, state.filtered.length - 1));
        state.flipped = false;
        state.locked = false;
        elements.card.classList.remove('is-flipped');
        elements.locked.hidden = true;
        elements.empty.hidden = state.filtered.length > 0;
        elements.workspace.hidden = state.filtered.length === 0;
        if (!state.filtered.length) {
          updateSummary();
          return;
        }
        const card = state.filtered[state.index];
        const frenchFirst = elements.direction.value === 'fr-en';
        elements.front.textContent = frenchFirst ? card.french : card.english;
        elements.back.textContent = frenchFirst ? card.english : card.french;
        elements.frontLanguage.textContent = frenchFirst ? i18n.french : i18n.english;
        elements.backLanguage.textContent = frenchFirst ? i18n.english : i18n.french;
        elements.sourceLabel.textContent = card.sourceTitle;
        elements.categoryLabel.textContent = card.category;
        elements.kindLabel.textContent = card.kind === 'sentence' ? i18n.sentence : i18n.vocabulary;
        elements.audio.hidden = !card.audio;
        elements.previous.disabled = state.index === 0;
        elements.progress.textContent = format(i18n.progress, { current: state.index + 1, total: state.filtered.length.toLocaleString() });
        updateSummary();
      };

      const flip = () => {
        if (!state.filtered.length || state.locked) return;
        state.flipped = !state.flipped;
        elements.card.classList.toggle('is-flipped', state.flipped);
      };

      const showLock = () => {
        if (member || state.lockedCount < 1) return false;
        state.locked = true;
        elements.workspace.hidden = true;
        elements.locked.hidden = false;
        elements.lockedCopy.textContent = format(i18n.lockedCopy, { count: state.lockedCount.toLocaleString() });
        elements.locked.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
        return true;
      };

      const next = () => {
        if (!state.filtered.length) return;
        if (state.index >= state.filtered.length - 1) {
          if (!showLock()) state.index = 0;
        } else {
          state.index += 1;
        }
        if (!state.locked) render();
      };

      const previous = () => {
        if (state.locked) {
          state.locked = false;
          elements.locked.hidden = true;
          elements.workspace.hidden = false;
          render();
          return;
        }
        if (state.index > 0) state.index -= 1;
        render();
      };

      const playAudio = async () => {
        const card = state.filtered[state.index];
        if (!card?.audio) return;
        stopAudio();
        const queue = [card.audio, card.audioSecondary].filter(Boolean);
        elements.audio.setAttribute('aria-busy', 'true');
        const playNext = () => {
          const source = queue.shift();
          if (!source) {
            stopAudio();
            return;
          }
          const audio = new Audio(source);
          state.currentAudio = audio;
          audio.preload = 'none';
          audio.addEventListener('ended', playNext, { once: true });
          audio.addEventListener('error', () => {
            stopAudio();
            elements.live.textContent = i18n.audioError;
          }, { once: true });
          audio.play().catch(() => {
            stopAudio();
            elements.live.textContent = i18n.audioError;
          });
        };
        elements.live.textContent = format(i18n.playing, { term: card.french });
        playNext();
      };

      const rate = (again) => {
        const card = state.filtered[state.index];
        if (!card) return;
        if (again) {
          state.reviewIds.add(card.id);
          elements.live.textContent = i18n.markedAgain;
        } else {
          state.reviewIds.delete(card.id);
          elements.live.textContent = i18n.markedKnown;
        }
        save();
        if (!again && state.reviewOnly) {
          state.index = 0;
          render();
          return;
        }
        next();
      };

      const shuffle = () => {
        for (let index = state.cards.length - 1; index > 0; index -= 1) {
          const target = Math.floor(Math.random() * (index + 1));
          [state.cards[index], state.cards[target]] = [state.cards[target], state.cards[index]];
        }
        state.index = 0;
        render();
      };

      const resetFilters = () => {
        elements.source.value = 'all';
        elements.category.value = 'all';
        elements.mode.value = 'mixed';
        state.reviewOnly = false;
        elements.review.setAttribute('aria-pressed', 'false');
        state.index = 0;
        save();
        render();
      };

      const discoverPageUrls = async () => {
        const response = await fetch('/sitemap.xml', { credentials: 'same-origin' });
        if (!response.ok) throw new Error('sitemap');
        const rootXml = new DOMParser().parseFromString(await response.text(), 'application/xml');
        const locations = [...rootXml.querySelectorAll('loc')].map((node) => node.textContent.trim());
        const pageMaps = locations.filter((value) => /sitemap_pages_/i.test(value));
        const pageLocations = [];
        if (pageMaps.length) {
          const maps = await Promise.all(pageMaps.map(async (url) => {
            const mapUrl = new URL(url, window.location.origin);
            mapUrl.protocol = window.location.protocol;
            mapUrl.host = window.location.host;
            const mapResponse = await fetch(mapUrl, { credentials: 'same-origin' });
            if (!mapResponse.ok) return [];
            const xml = new DOMParser().parseFromString(await mapResponse.text(), 'application/xml');
            return [...xml.querySelectorAll('loc')].map((node) => node.textContent.trim());
          }));
          pageLocations.push(...maps.flat());
        } else {
          pageLocations.push(...locations);
        }
        const currentPath = '/pages/french-course';
        return [...new Set(pageLocations.map((value) => {
          try {
            const discoveredUrl = new URL(value, window.location.origin);
            if (!discoveredUrl.pathname.startsWith(pagePrefix) || discoveredUrl.pathname === currentPath) return null;
            return new URL(discoveredUrl.pathname, window.location.origin).href;
          } catch (_error) {
            return null;
          }
        }).filter(Boolean))].sort().slice(0, discoveryLimit);
      };

      const loadSource = async (sourceUrl) => {
        const url = new URL(sourceUrl, window.location.origin);
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`source-${response.status}`);
        const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const scripts = [...documentPage.querySelectorAll('script[type="application/json"]')];
        const categoryLabels = new Map();
        let categoryTotal = 0;
        scripts.forEach((node) => {
          const attribute = node.getAttributeNames().find((name) => name.startsWith('data-')) || '';
          if (!attribute.includes('categories')) return;
          const categories = safeJson(node, []);
          if (!Array.isArray(categories)) return;
          categories.forEach((category) => {
            if (!Array.isArray(category)) return;
            categoryLabels.set(String(category[0]), String(category[1] || category[0]));
            const total = Number(category[category.length - 1]);
            if (Number.isFinite(total)) categoryTotal += total;
          });
        });
        const sourceId = url.pathname.split('/').filter(Boolean).pop();
        const sourceTitle = cleanTitle(documentPage.querySelector('h1')?.textContent, sourceId.replaceAll('-', ' '));
        const audioBase = documentPage.querySelector('[data-audio-path]')?.dataset.audioPath || '';
        let rowCount = 0;
        const cards = [];
        scripts.forEach((node) => {
          const dataset = node.getAttributeNames().find((name) => name.startsWith('data-')) || '';
          if (!dataset || dataset.includes('categories') || dataset.includes('fbfc-i18n')) return;
          const rows = safeJson(node, null);
          if (!Array.isArray(rows) || !rows.length) return;
          if (!Array.isArray(rows[0]) && (typeof rows[0] !== 'object' || rows[0] === null)) return;
          const isMemberDataset = dataset.includes('member');
          if (!member && isMemberDataset) return;
          rowCount += rows.length;
          rows.forEach((row, rowIndex) => {
            cards.push(...normalizeRow(row, {
              sourceId,
              sourceTitle,
              sourceUrl: url.pathname,
              dataset,
              rowIndex,
              audioBase,
              categoryLabels,
              free: !isMemberDataset
            }));
          });
        });
        if (!cards.length) return;
        state.cards.push(...cards);
        state.sources.set(sourceId, sourceTitle);
        cards.forEach((card) => state.categories.set(card.categoryKey, `${sourceTitle}: ${card.category}`));
        if (!member) {
          let totalRows = categoryTotal;
          if (!totalRows) {
            const text = documentPage.body.textContent || '';
            const remaining = text.match(/remaining\s+([\d,.\s]+)\s+(?:entries|words|phrases|verbs|adjectives|nouns|numbers|idioms|questions)/i);
            if (remaining) totalRows = rowCount + Number(remaining[1].replace(/[^\d]/g, ''));
            const more = text.match(/unlock\s+([\d,.]+)\s+more\b/i);
            if (!totalRows && more) totalRows = rowCount + Number(more[1].replace(/[^\d]/g, ''));
            const headingTotal = documentPage.querySelector('h1')?.textContent.match(/([\d,.]+)/);
            if (!totalRows && headingTotal) totalRows = Number(headingTotal[1].replace(/[^\d]/g, ''));
          }
          if (totalRows > rowCount) state.lockedCount += totalRows - rowCount;
        }
        setOptions();
        updateSummary();
        if (state.cards.length && elements.workspace.hidden) render();
      };

      const loadAll = async () => {
        try {
          const urls = await discoverPageUrls();
          state.discoveredSources = urls.length;
          elements.load.textContent = format(i18n.loadingProgress, { loaded: 0, total: urls.length });
          const queue = [...urls];
          const worker = async () => {
            while (queue.length) {
              const url = queue.shift();
              try { await loadSource(url); }
              catch (error) {
                state.failedSources += 1;
                console.error('[French flashcards] Source failed', url, error);
              }
              state.loadedSources += 1;
              elements.load.textContent = format(i18n.loadingProgress, { loaded: state.loadedSources, total: state.discoveredSources });
            }
          };
          await Promise.all(Array.from({ length: Math.min(4, Math.max(1, urls.length)) }, worker));
          if (!state.cards.length) throw new Error('empty');
          elements.load.textContent = format(i18n.loaded, { cards: state.cards.length.toLocaleString(), sources: state.sources.size.toLocaleString() });
          if (state.failedSources) {
            elements.error.hidden = false;
            elements.error.textContent = i18n.partialError;
          }
          render();
        } catch (error) {
          console.error('[French flashcards] Deck failed', error);
          elements.load.hidden = true;
          elements.error.hidden = false;
          elements.error.textContent = i18n.loadError;
          elements.empty.hidden = false;
        }
      };

      elements.card.addEventListener('click', flip);
      elements.flip.addEventListener('click', flip);
      elements.previous.addEventListener('click', previous);
      elements.next.addEventListener('click', next);
      elements.audio.addEventListener('click', playAudio);
      elements.again.addEventListener('click', () => rate(true));
      elements.known.addEventListener('click', () => rate(false));
      elements.shuffle.addEventListener('click', shuffle);
      elements.restart.addEventListener('click', resetFilters);
      elements.backToDeck.addEventListener('click', previous);
      elements.review.addEventListener('click', () => {
        if (!state.reviewIds.size) {
          elements.live.textContent = i18n.reviewEmpty;
          return;
        }
        state.reviewOnly = !state.reviewOnly;
        elements.review.setAttribute('aria-pressed', String(state.reviewOnly));
        state.index = 0;
        render();
      });
      [elements.direction, elements.mode, elements.source, elements.category].forEach((control) => control.addEventListener('change', () => {
        state.index = 0;
        save();
        render();
      }));

      let pointerStart = null;
      elements.card.addEventListener('pointerdown', (event) => { pointerStart = [event.clientX, event.clientY]; });
      elements.card.addEventListener('pointerup', (event) => {
        if (!pointerStart) return;
        const horizontal = event.clientX - pointerStart[0];
        const vertical = event.clientY - pointerStart[1];
        pointerStart = null;
        if (Math.abs(horizontal) < 55 || Math.abs(horizontal) < Math.abs(vertical)) return;
        if (horizontal < 0) next(); else previous();
      });

      root.addEventListener('keydown', (event) => {
        if (event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement || event.target instanceof HTMLTextAreaElement) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
        if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); flip(); }
        if (event.key.toLowerCase() === 'a') { event.preventDefault(); playAudio(); }
      });

      loadAll();
    };

    roots.forEach(initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["french-translator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-french-translator]');

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const i18n = JSON.parse(root.querySelector('[data-fbtr-i18n]').textContent);
      const elements = {
        input: root.querySelector('[data-fbtr-input]'),
        submit: root.querySelector('[data-fbtr-submit]'),
        clear: root.querySelector('[data-fbtr-clear]'),
        swap: root.querySelector('[data-fbtr-swap]'),
        directions: [...root.querySelectorAll('[data-fbtr-direction]')],
        sourceLabel: root.querySelector('[data-fbtr-source-label]'),
        targetLabel: root.querySelector('[data-fbtr-target-label]'),
        counter: root.querySelector('[data-fbtr-counter]'),
        resultColumn: root.querySelector('[data-fbtr-result-column]'),
        empty: root.querySelector('[data-fbtr-empty]'),
        emptyTitle: root.querySelector('[data-fbtr-empty-title]'),
        loading: root.querySelector('[data-fbtr-loading]'),
        message: root.querySelector('[data-fbtr-message]'),
        messageTitle: root.querySelector('[data-fbtr-message-title]'),
        messageBody: root.querySelector('[data-fbtr-message-body]'),
        retry: root.querySelector('[data-fbtr-retry]'),
        answer: root.querySelector('[data-fbtr-answer]'),
        translation: root.querySelector('[data-fbtr-translation]'),
        copy: root.querySelector('[data-fbtr-copy]'),
        alternatives: root.querySelector('[data-fbtr-alternatives]'),
        alternativesList: root.querySelector('[data-fbtr-alternatives-list]'),
        live: root.querySelector('[data-fbtr-live]')
      };

      const state = {
        direction: 'fr-en',
        controller: null,
        liveTimer: null,
        cache: new Map(),
        recentRequests: [],
        lastQuery: ''
      };

      const decodeText = (value) => {
        const decoder = document.createElement('textarea');
        decoder.innerHTML = String(value || '');
        return decoder.value.trim();
      };

      const setBusy = (busy) => {
        elements.resultColumn.setAttribute('aria-busy', String(busy));
        elements.submit.disabled = busy;
        elements.directions.forEach((button) => { button.disabled = busy; });
        elements.swap.disabled = busy;
      };

      const hideStates = () => {
        elements.empty.hidden = true;
        elements.loading.hidden = true;
        elements.message.hidden = true;
        elements.answer.hidden = true;
        elements.copy.hidden = true;
      };

      const showEmpty = () => {
        hideStates();
        elements.empty.hidden = false;
      };

      const showLoading = () => {
        hideStates();
        elements.loading.hidden = false;
        elements.live.textContent = i18n.loading;
      };

      const showMessage = (title, body, canRetry = false) => {
        hideStates();
        elements.messageTitle.textContent = title;
        elements.messageBody.textContent = body;
        elements.retry.hidden = !canRetry;
        elements.message.hidden = false;
        elements.live.textContent = `${title} ${body}`;
      };

      const showAnswer = (translation, alternatives) => {
        hideStates();
        elements.translation.textContent = translation;
        elements.translation.lang = state.direction === 'fr-en' ? 'en' : 'fr';
        elements.alternativesList.replaceChildren();
        alternatives.forEach((alternative) => {
          const item = document.createElement('li');
          item.textContent = alternative;
          elements.alternativesList.append(item);
        });
        elements.alternatives.hidden = alternatives.length === 0;
        elements.answer.hidden = false;
        elements.copy.hidden = false;
        elements.live.textContent = i18n.translated;
      };

      const updateInterface = () => {
        const frenchFirst = state.direction === 'fr-en';
        elements.sourceLabel.textContent = frenchFirst ? i18n.sourceFrench : i18n.sourceEnglish;
        elements.targetLabel.textContent = frenchFirst ? i18n.targetEnglish : i18n.targetFrench;
        elements.input.placeholder = frenchFirst ? i18n.placeholderFrench : i18n.placeholderEnglish;
        elements.submit.textContent = frenchFirst ? i18n.translateEnglish : i18n.translateFrench;
        elements.emptyTitle.textContent = frenchFirst ? i18n.emptyEnglish : i18n.emptyFrench;
        elements.input.lang = frenchFirst ? 'fr' : 'en';
        elements.directions.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.fbtrDirection === state.direction));
        });
        showEmpty();
      };

      const updateInputState = () => {
        elements.counter.textContent = `${elements.input.value.length} / 450`;
        elements.clear.disabled = elements.input.value.length === 0;
      };

      const cacheSet = (key, value) => {
        if (state.cache.size >= 30) state.cache.delete(state.cache.keys().next().value);
        state.cache.set(key, value);
      };

      const extractResult = (data, query) => {
        if (!data || Number(data.responseStatus) !== 200) return null;
        const primary = decodeText(data.responseData?.translatedText);
        if (!primary || /^MYMEMORY WARNING:/i.test(primary)) return null;

        const normalizePhrase = (value) => decodeText(value)
          .normalize('NFKC')
          .toLocaleLowerCase()
          .replace(/[.!?…]+$/u, '')
          .replace(/\s+/g, ' ')
          .trim();
        const normalizedQuery = normalizePhrase(query);

        const seen = new Set([primary.toLocaleLowerCase()]);
        const alternatives = [];
        (Array.isArray(data.matches) ? data.matches : []).forEach((match) => {
          const candidate = decodeText(match?.translation);
          const key = candidate.toLocaleLowerCase();
          if (normalizePhrase(match?.segment) !== normalizedQuery) return;
          if (!candidate || seen.has(key) || Number(match?.match || 0) < 0.65) return;
          seen.add(key);
          alternatives.push(candidate);
        });

        const unchanged = primary.localeCompare(query, undefined, { sensitivity: 'accent' }) === 0;
        const confidence = Number(data.responseData?.match || 0);
        if (unchanged && confidence < 0.95 && !alternatives.length) return null;
        return { primary, alternatives: alternatives.slice(0, 5) };
      };

      const translate = async () => {
        window.clearTimeout(state.liveTimer);
        state.liveTimer = null;
        const query = elements.input.value.trim();
        state.lastQuery = query;
        if (!query) {
          showMessage(i18n.emptyInput, '', false);
          elements.input.focus();
          return;
        }

        if (new TextEncoder().encode(query).length > 500) {
          showMessage(i18n.lengthTitle, i18n.lengthBody, false);
          return;
        }

        if (!navigator.onLine) {
          showMessage(i18n.offlineTitle, i18n.offlineBody, true);
          return;
        }

        const now = Date.now();
        state.recentRequests = state.recentRequests.filter((time) => now - time < 60000);
        if (state.recentRequests.length >= 20) {
          showMessage(i18n.rateTitle, i18n.rateBody, false);
          return;
        }

        const cacheKey = `${state.direction}:${query}`;
        if (state.cache.has(cacheKey)) {
          const cached = state.cache.get(cacheKey);
          showAnswer(cached.primary, cached.alternatives);
          return;
        }

        state.controller?.abort();
        state.controller = new AbortController();
        const controller = state.controller;
        const timeout = window.setTimeout(() => controller.abort('timeout'), 12000);
        state.recentRequests.push(now);
        setBusy(true);
        showLoading();

        try {
          const url = new URL(root.dataset.endpoint);
          url.searchParams.set('q', query);
          url.searchParams.set('langpair', state.direction === 'fr-en' ? 'fr|en' : 'en|fr');
          const response = await fetch(url.toString(), {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-store',
            referrerPolicy: 'no-referrer',
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const data = await response.json();
          const result = extractResult(data, query);
          if (!result) {
            showMessage(i18n.noResultTitle, i18n.noResultBody, false);
            return;
          }
          cacheSet(cacheKey, result);
          showAnswer(result.primary, result.alternatives);
        } catch (error) {
          if (controller.signal.aborted && controller.signal.reason !== 'timeout') return;
          if (controller.signal.reason === 'timeout') {
            showMessage(i18n.timeoutTitle, i18n.timeoutBody, true);
          } else {
            console.error('[French translator] Request failed', error);
            showMessage(i18n.errorTitle, i18n.errorBody, true);
          }
        } finally {
          window.clearTimeout(timeout);
          if (state.controller === controller) {
            state.controller = null;
            setBusy(false);
          }
        }
      };

      const scheduleTranslation = () => {
        updateInputState();
        window.clearTimeout(state.liveTimer);
        state.controller?.abort();
        showEmpty();

        if (!elements.input.value.trim()) return;

        state.liveTimer = window.setTimeout(() => {
          state.liveTimer = null;
          translate();
        }, 650);
      };

      const setDirection = (direction) => {
        if (direction === state.direction) return;
        window.clearTimeout(state.liveTimer);
        state.controller?.abort();
        state.direction = direction;
        updateInterface();
        scheduleTranslation();
      };

      const clear = () => {
        window.clearTimeout(state.liveTimer);
        state.liveTimer = null;
        state.controller?.abort();
        elements.input.value = '';
        state.lastQuery = '';
        updateInputState();
        showEmpty();
        elements.input.focus();
      };

      const copyTranslation = async () => {
        const text = elements.translation.textContent;
        if (!text) return;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
          } else {
            const field = document.createElement('textarea');
            field.value = text;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.append(field);
            field.select();
            document.execCommand('copy');
            field.remove();
          }
          elements.live.textContent = i18n.copied;
        } catch (error) {
          elements.live.textContent = i18n.copyFailed;
        }
      };

      elements.submit.addEventListener('click', translate);
      elements.retry.addEventListener('click', translate);
      elements.clear.addEventListener('click', clear);
      elements.copy.addEventListener('click', copyTranslation);
      elements.swap.addEventListener('click', () => setDirection(state.direction === 'fr-en' ? 'en-fr' : 'fr-en'));
      elements.directions.forEach((button) => button.addEventListener('click', () => setDirection(button.dataset.fbtrDirection)));
      elements.input.addEventListener('input', scheduleTranslation);
      elements.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.shiftKey) return;
        if (event.isComposing) return;
        event.preventDefault();
        translate();
      });

      updateInputState();
      updateInterface();
    };

    roots.forEach(initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
